'use strict';

import type { ILayerView } from "../model/Layer";

const es = global.es; // TODO Remove dependency!
const $: JQueryStatic = global.$;
const Cache = global.Cache; // jscache

const SALESFORCE_MAX_BATCH_SIZE = 25;

const salesforce_status = {
    OK: 200, //“OK” success code, for GET or HEAD request.
    CREATED_OK: 201, //“Created” success code, for POST request.
    NO_CONTENT_OK: 204 //“No Content” success code, for DELETE request.
};

const salesforceRestMethods = {
    'PATCH': {
        method: 'PATCH',
        status_ok: salesforce_status.NO_CONTENT_OK
    },
    'POST': {
        method: 'POST',
        status_ok: salesforce_status.CREATED_OK
    },
    'GET': {
        method: 'GET',
        status_ok: salesforce_status.OK
    },
    'DELETE': {
        method: 'DELETE',
        status_ok: salesforce_status.NO_CONTENT_OK
    },
    'POST_BULK_PATCH': {
        method: 'POST',
        status_ok: salesforce_status.OK,
        status_subrequest_ok: [salesforce_status.CREATED_OK, salesforce_status.NO_CONTENT_OK]
    }
};

const sfObjects = {
    'Lead': 'Lead',
    'Account': 'Account',
    'Contact': 'Contact',
    'Opportunity': 'Opportunity',
    'Custom': 'Custom'
};
const singleSFActions = {
    "LogACall": "LogACall",
    "NewTask": "NewTask",
    "NewEvent": "NewEvent",
    "Edit": "Edit",
    "CreateContact": "CreateContact",
    "AddToCampaign": "AddToCampaign",
    "Open": "Open",
    "ChangeOwner": "ChangeOwner"
};
const singleNonSFActions = {
    "CreateContact": "CreateContact",
    "CreateLead": "CreateLead"
};

// var quickActionOperation = [singleSFActions.LogACall];
const quickActionOperations = {
    'LogACall': {
        name: 'LogACall',
        type: 'LogACall'
    }
};

const singleSFObjectAllowedActions = {};

// Contact
//     Log A Call
//     New Event
//     New Task
//     Edit
//     Open
//     ChangeOwner
//     Add to Campaign

singleSFObjectAllowedActions[sfObjects.Contact] = [singleSFActions.LogACall, singleSFActions.NewEvent, singleSFActions.NewTask, singleSFActions.Edit, singleSFActions.Open, singleSFActions.ChangeOwner, singleSFActions.AddToCampaign];
// Oportunity
//     Log A Call
//     New Event
//     New Task
//     Edit
//     Open
//     ChangeOwner

singleSFObjectAllowedActions[sfObjects.Opportunity] = [singleSFActions.NewEvent, singleSFActions.NewTask, singleSFActions.Edit, singleSFActions.Open, singleSFActions.ChangeOwner];

// Account
//     Log A Call
//     New Event
//     New Task
//     Edit
//     Open
//     ChangeOwner
//     Create Contact for Account

singleSFObjectAllowedActions[sfObjects.Account] = [singleSFActions.LogACall, singleSFActions.NewEvent, singleSFActions.NewTask, singleSFActions.Edit, singleSFActions.Open, singleSFActions.ChangeOwner, singleSFActions.CreateContact];

// Lead
//     Log A Call
//     New Event
//     New Task
//     Edit
//     Open
//     ChangeOwner
//     Add to Campaign
singleSFObjectAllowedActions[sfObjects.Lead] = [singleSFActions.LogACall, singleSFActions.NewEvent, singleSFActions.NewTask, singleSFActions.Edit, singleSFActions.Open, singleSFActions.ChangeOwner, singleSFActions.AddToCampaign];

// Custom object
//  Open
//  Edit
//  ChangeOwner
singleSFObjectAllowedActions[sfObjects.Custom] = [singleSFActions.Edit, singleSFActions.Open, singleSFActions.ChangeOwner];

const multiSFActions = {
    "AddToCampaign": "AddToCampaign",
    "ChangeOwner": "ChangeOwner",
    "UpdateField": "UpdateField"
};

//Non SF Points (drop point or any point from a non sf layer)
//     Create (Contact or Lead)
const multiSFObjectAllowedActions = [];
multiSFObjectAllowedActions[sfObjects.Contact] = [multiSFActions.AddToCampaign, multiSFActions.ChangeOwner, multiSFActions.UpdateField];
multiSFObjectAllowedActions[sfObjects.Lead] = [multiSFActions.AddToCampaign, multiSFActions.ChangeOwner, multiSFActions.UpdateField];
multiSFObjectAllowedActions[sfObjects.Account] = [multiSFActions.ChangeOwner, multiSFActions.UpdateField];
multiSFObjectAllowedActions[sfObjects.Opportunity] = [multiSFActions.ChangeOwner, multiSFActions.UpdateField];
multiSFObjectAllowedActions[sfObjects.Custom] = [multiSFActions.ChangeOwner, multiSFActions.UpdateField];

/**
 * Mapping between feature attributes created as a result of importing accounts
 * and salesforce contact attributes
 * @type {{PHONE: string, BILLINGSTREET: string, BILLINGCITY: string, BILLINGSTATE: string, BILLINGPOSTALCODE: string, BILLINGCOUNTRY: string, FAX: string}}
 */
const accountToContactSFAttrs = {
    'PHONE': 'Phone',
    'BILLINGSTREET': 'MailingStreet',
    'BILLINGCITY': 'MailingCity',
    'BILLINGSTATE': 'MailingState',
    'BILLINGPOSTALCODE': 'MailingPostalCode',
    'BILLINGCOUNTRY': 'MailingCountry',
    'FAX': 'Fax'
};

    //Non SF Points (drop point or any point from a non sf layer)
//     Create (Contact or Lead)
const singleNonSFPointObjectAllowedActions = [];
singleNonSFPointObjectAllowedActions[sfObjects.Contact] = [singleNonSFActions.CreateContact];
singleNonSFPointObjectAllowedActions[sfObjects.Lead] = [singleNonSFActions.CreateLead];
const addressParams = {
     'Contact': {
        'STREET' : 'MailingStreet',
        'ZIP'    : 'MailingPostalCode',
        'CITY'   : 'MailingCity',
        'STATE'  : 'MailingState',
        'COUNTRY': 'MailingCountry'
    },
    'Lead': {
        'STREET' : 'Street',
        'ZIP'    : 'PostalCode',
        'CITY'   : 'City',
        'STATE'  : 'State',
        'COUNTRY': 'Country'
    }
};

export default class SFDCClient {
    private signedRequest: any;
    private sfCanvasClient;

    private cache;
    private quickActions;
    private readonly clientCreatedAtMs: number = Date.now();

    constructor(signedRequest: any, sfCanvasClient) {
        if (!signedRequest) {
            throw new Error("SFDC signed request not available yet or method called while not embedded in SFDC platform");
        }

        const tokenHint = signedRequest?.client?.oauthToken ? String(signedRequest.client.oauthToken).slice(-12) : "(none)";
        es.log.log('Initializing sfdcClient',
            'tokenSuffix=...' + tokenHint,
            'sf_issuedAt=' + signedRequest?.issuedAt,
            'now=' + this.clientCreatedAtMs,
            'userId=' + signedRequest?.context?.user?.userId);

        this.signedRequest = signedRequest;
        this.sfCanvasClient = sfCanvasClient;

        this.cache = new Cache();
        this.quickActions = {};

        this.canvasResize();

        if (!signedRequest.context.links.restUrl.includes(es.salesforceSettings.apiVersion)) {
            console.warn(`Server and Client API version mismatch:\n client: ${signedRequest.context.links.restUrl} \n server: ${es.salesforceSettings.apiVersion}`)
        }
    }

    /**
     * Checks if operation is valid SalesForce operation
     * @param action Javascript object that defines operation
     * { object : 'Lead',
     *   operation : 'LogACall',
     *   params : {..}
     * }
     *
     * @returns {boolean}
     */
    private isValidSingleSFPointOperation(operation): boolean {
        return !!(operation.object && sfObjects[operation.object] && singleSFObjectAllowedActions[operation.object] && singleSFObjectAllowedActions[operation.object].includes(operation.action));
    }

    /**
     * Checks if operation is valid SalesForce operation for multiple salesforce points
     * @param action Javascript object that defines operation
     * { object : 'Lead',
     *   operation : 'UpdateField',
     *   params : {..}
     * }
     *
     * @returns {boolean}
     */
    private isValidMultiSFPointOperation(operation): boolean {
        return !!(operation.object && sfObjects[operation.object] && multiSFObjectAllowedActions[operation.object] && multiSFObjectAllowedActions[operation.object].includes(operation.action));
    }

    /**
     * Checks if operation is valid SalesForce operation
     * @param request Javascript object that defines operation
     * { object : 'Lead',
     *   operation : 'Create',
     *   params : {..}
     * }
     *
     * @returns {boolean}
     */
    private isValidSingleFromNonSFPointOperation(request): boolean {
        return !!(request.object && singleNonSFPointObjectAllowedActions[request.object] && singleNonSFPointObjectAllowedActions[request.object].includes(request.action));

    }

    /**
     * 
     */
    canvasResize() {
        this.publish('ess_cnv.resize');
    }

    /**
     * 
     * @param event 
     * @param payload 
     */
    private publish(event: string, payload?: any) {
        this.sfCanvasClient.publish(this.signedRequest.client, {
            "name": event,
            "payload": payload
        });
    }

    /**
     * 
     * @param eventName 
     * @param callback 
     */
    private subscribe(eventName: string, callback: Function) {
        this.sfCanvasClient.subscribe(this.signedRequest.client, {
            "name": eventName,
            "onData": callback
        });
    }

    /**
     * public method. LogACall
     * @param type type of entity
     * @param data
     *      {
     *      id: object id,
     *      subject: subject of the call
     *      comment: comment for the call
     *      }
     * @returns a promise
     */
    singleSFPoint_LogACall(type, data): JQueryDeferred<any> {
        const operation = {
            object: type,
            action: singleSFActions.LogACall,
            params: data
        };

        return this.logACall(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id: object id
     *      sameTab: boolean
     *      }
     */
    singleSFPoint_NewEvent(type, data) {
        const newData = $.extend(data, {subtype: 'Event'});
        const operation = {
            object: type,
            action: singleSFActions.NewEvent,
            params: newData
        };

        return this.addToCreate(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id: object id
     *      sameTab: boolean
     *      }
     */
    singleSFPoint_NewTask(type, data) {
        const newData = $.extend(data, {subtype: 'Task'});
        const operation = {
            object: type,
            action: singleSFActions.NewTask,
            params: newData
        };

        return this.addToCreate(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id: object id
     *      sameTab: boolean
     *      }
     */
    singleSFPoint_Edit(type, data) {
        const operation = {
            object: type,
            action: singleSFActions.Edit,
            params: data
        };

        return this.sendCanvasSingleSFPointOperation(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id: object id
     *      sameTab: boolean
     *      }
     */
    singleSFPoint_Open(type, data) {
        const operation = {
            object: type,
            action: singleSFActions.Open,
            params: data
        };

        return this.sendCanvasSingleSFPointOperation(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id: id,
     *      ownerId: ownerId
     *      }
     *
     * @returns a promise
     */
    singleSFPoint_ChangeOwner(type, data) {
        const operation = {
            object: type,
            action: singleSFActions.ChangeOwner,
            params: data
        };

        return this.changeOwner(operation);
    }

    /**
     * public method
     * @param type
     * @param data
     *      {
     *      id:'00Q0Y0000064nrgUAA',
     *      campaignId:'7010Y0000001DUhQAM'
     *      }
     *
     * @returns a promise
     */
    singleSFPoint_AddCampaign(type, data): JQueryDeferred<any> {
        const operation = {
            object: type,
            action: singleSFActions.AddToCampaign,
            params: data
        };

        return this.addToCampaign(operation);
    }

    /**
     * Adapts feature attributes from salesforce Account to salesforce Contact.
     * 
     * @param featureAttrs
     */
    private adaptFeatureAttrsToSFAttrs(featureAttrs) {
        const mappedAttr = {};
        Object.keys(featureAttrs).map((objectKey, index) => { // NOSONAR
            const mappingAccountToContactSFAttr = accountToContactSFAttrs[objectKey];
            if (mappingAccountToContactSFAttr) {
                mappedAttr[mappingAccountToContactSFAttr] = featureAttrs[objectKey];
            }
        });

        return mappedAttr;
    }

    /**
     * public method
     * @param type
     * @param data
     */
    singleSFPoint_CreateContact(type, data, featureAttrs) {
        if (featureAttrs) {
            const mappedAttributes = this.adaptFeatureAttrsToSFAttrs(featureAttrs);
            $.extend(data, mappedAttributes);
        }

        const operation = {
            object: type,
            action: singleSFActions.CreateContact,
            params: data
        };

        return this.sendCanvasSingleSFPointOperation(operation);
    }

    /**
     * public method
     * Retrieves all operations available for an object type (Account, Lead, Contact, Opportunity) for single salesforce points (singleSFPoints)
     * @param objectType
     * @returns List of operations allowed:
     * {
     *      "LogACall",
     *      "NewTask"
     *      "NewEvent"
     *      ...
     *      "ChangeOwner"
     * }
     */
    listSingleSFPoint_Operations(objectType: string) {
        if (!sfObjects[objectType]) {
            console.error("Unknown objectType " + objectType);
            return {};
        }

        return singleSFObjectAllowedActions[objectType];
    }

    /**
     * public method
     * performs the updated of the specified attribute with the specified value
     * for the selected salesforce points.
     * @param type look sfObjects ('Lead', 'Account', 'Opportunity', 'Contact')
     * @param data contains information about which objects are selected and the attribute name and attribute value
     * {
     *  ids : [id1, id2, ..., idn],
     *  attributeName : 'attributeName',
     *  attributeValue: 'attributeValue,
     * }
     * @returns deferred that will be resolved once all elements are processed. With status information
     * status = {
     *      total: operations to process,
     *      ok: operations processed ok,
     *      error: operations processed with error,
     *      errorMessage: [
     *          {
     *              id : id for element that returned error,
     *              message: error message returned
     *          }
     *      ]
     *  }
     */
    multiSFPoint_updateField(type, data): JQueryDeferred<any> {
        const operation = {
            object: type,
            action: multiSFActions.UpdateField,
            params: data
        };

        return this.bulk_updateField(operation);
    }

    /**
     * 
     * @param ids 
     * @param status 
     * @param urlBase 
     * @param method 
     * @param attributeName 
     * @param attributeValue 
     * @param prepareBatchSubRequest 
     * @param objectType 
     * 
     * @returns 
     */
    private processBatchOperation(ids, status, urlBase: string, method, attributeName: string, attributeValue, prepareBatchSubRequest: Function, objectType): JQueryDeferred<any> {
        const subRequests = [];
        ids.forEach((element) => {
            subRequests.push(prepareBatchSubRequest(element, urlBase, method, attributeName, attributeValue, objectType));
        });
        const batchRequests = {
            batchRequests: subRequests
        };
        const batchUrl = this.signedRequest.context.links.restUrl + "composite/batch/";

        return this.salesforceRestCall(batchUrl, salesforceRestMethods.POST_BULK_PATCH, batchRequests, null, {suppressDefaultErrorHandling: true}).then((okResult) => {
            if (!okResult.hasErrors) {
                status.ok += batchRequests.batchRequests.length;
            } else {
                for (let i = 0; i < batchRequests.batchRequests.length; i++) {
                    const currentResult = okResult.results[i];

                    if (!salesforceRestMethods.POST_BULK_PATCH.status_subrequest_ok.includes(currentResult.statusCode)) {
                        status.error++;
                        const errorInfo = {
                            id: ids[i],
                            message: currentResult.result[0]
                        };
                        status.errorMessage.push(errorInfo);
                    } else {
                        status.ok++;
                    }
                }
            }
        });
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private bulk_updateField(operation): JQueryDeferred<any> {
        if (!this.isValidMultiSFPointOperation(operation)) {
            return es.util.deferred.rejected("Operation is not allowed");
        }

        if (!(operation.params && operation.params.ids && operation.params.ids.length > 0 && operation.params.attributeValue !== undefined && operation.params.attributeName )) {
            return es.util.deferred.rejected("Operation is missing mandatory parameters");
        }

        operation.params.ids = _.uniq(operation.params.ids);
        if (operation.params.ids.length > es.salesforceSettings.sfMaxBulkEditCount) {
            return es.util.deferred.rejected("Operation is limited to " + es.salesforceSettings.sfMaxBulkEditCount + " number of points");
        }

        const status = {
            total: operation.params.ids.length,
            ok: 0,
            error: 0,
            errorMessage: []
        };

        let urlBase = this.signedRequest.context.links.sobjectUrl + operation.object + '/';
        if (operation.object === sfObjects.Custom) {
            urlBase = this.signedRequest.context.links.sobjectUrl + operation.params.objectName + '/';
        }

        let batchIteration = 0;
        let start = 0;
        const ids = operation.params.ids;
        const dfds = [];

        const prepareSubrequest_bulkEdit = (element, urlBase: string, method,  attributeName: string, attributeValue) => {
            const url = urlBase + element;

            const request = {
                method: method,
                url: url,
                richInput: {}
            };
            request.richInput[attributeName] = attributeValue;
            return request;
        };

        while (start < ids.length) {
            const end = Math.min(SALESFORCE_MAX_BATCH_SIZE, ids.length - start);
            const subset = ids.slice(start, start + end);
            const dfd = this.processBatchOperation(subset, status, urlBase, salesforceRestMethods.PATCH.method, operation.params.attributeName, operation.params.attributeValue, prepareSubrequest_bulkEdit);
            dfds.push(dfd);
            batchIteration++;
            start = batchIteration * SALESFORCE_MAX_BATCH_SIZE;
        }

        return es.util.deferred.all(dfds).then(() => status);
    }

    /**
     * public method
     * performs the updated of the specified attribute with the specified value
     * for the selected salesforce points.
     * @param type look sfObjects ('Lead', 'Account', 'Opportunity', 'Contact')
     * @param data contains information about which objects are selected and the attribute name and attribute value
     * {
     *  ids : [id1, id2, ..., idn],
     *  campaignId : 'campaignId'
     * }
     * @returns deferred that will be resolved once all elements are processed. With status information
     * status = {
            total: operations to process,
            ok: operations processed ok,
            error: operations processed with error,
            errorMessage: [
                {
                    id : id for element that returned error,
                    message: error message returned
                }
            ]
        }
     */
    multiSFPoint_addToCampaign(type, data): JQueryDeferred<any> {
        const operation = {
            object: type,
            action: multiSFActions.AddToCampaign,
            params: data
        };

        return this.bulk_addToCampaign(operation);
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private bulk_addToCampaign(operation): JQueryDeferred<any> {
        if (!this.isValidMultiSFPointOperation(operation)) {
            return es.util.deferred.rejected("Operation is not allowed");
        }

        if (!(operation.params && operation.params.ids && operation.params.ids.length > 0 && operation.params.campaignId)) {
            return es.util.deferred.rejected("Operation is missing mandatory parameters");
        }

        operation.params.ids = _.uniq(operation.params.ids);
        if (operation.params.ids.length > es.salesforceSettings.sfMaxBulkEditCount) {
            return es.util.deferred.rejected("Operation is limited to " + es.salesforceSettings.sfMaxBulkEditCount + " number of points");
        }

        const status = {
            total: operation.params.ids.length,
            ok: 0,
            error: 0,
            errorMessage: []
        };

        const prepareSubrequest_bulkAddToCampaign = (element, url: string, method,  attributeName: string, attributeValue, objectType) => {
            const request = {
                method: method,
                url: url,
                richInput: {}
            };
            if (objectType === sfObjects.Lead) {
                request.richInput.LeadId = element;
            } else if (objectType === sfObjects.Contact) {
                request.richInput.ContactId = element;
            }
            request.richInput[attributeName] = attributeValue;
            return request;
        };

        let batchIteration = 0;
        let start = 0;
        const ids = operation.params.ids;
        const dfds = [];
        const url = this.signedRequest.context.links.sobjectUrl + "CampaignMember";
        while (start < ids.length) {
            const end = Math.min(SALESFORCE_MAX_BATCH_SIZE, ids.length - start);
            const subset = ids.slice(start, start + end);
            const dfd = this.processBatchOperation(subset, status, url, salesforceRestMethods.POST.method, 'CampaignId', operation.params.campaignId, prepareSubrequest_bulkAddToCampaign, operation.object);
            dfds.push(dfd);
            batchIteration++;
            start = batchIteration * SALESFORCE_MAX_BATCH_SIZE;
        }

        return es.util.deferred.all(dfds).then(() => status);
    }

    /**
     * Adapts operation information to an event that will be sent
     * to the remote visualforce page
     * @param operation
     * @returns
     *      {
     *          {
     *              channel: string,
     *              payload: {
     *                  object: *,
     *                  action: (string|*),
     *                  params: *
     *              }
     *          }
     *     }
     */
    private createEventFromOperation(operation) {
        return {
            channel: 'ess_cnv.' + operation.action,
            payload: {
                object: operation.object,
                action: operation.action,
                params: operation.params,
                recordTypeId: operation.recordTypeId
            }
        };
    }

    /**
     * 
     * @param operation 
     */
    private sendEventToRemoteCanvas(operation) {
        const event = this.createEventFromOperation(operation);
        this.publish(event.channel, event.payload);
    }

    /**
     * It receives an object with the following elements
     * {
     *      action: action from singleSFActions
     *      object: object from sfObjects
     *      params: all parameters that will be needed to perform the action on
     * }
     * and creates an event to communicate with remote visualforce page where the application
     * is running. This will let us use sforce.one api or windows.location
     * @param operation object that contains all information
     */
    private sendCanvasSingleSFPointOperation(operation) {
        es.log.log("sendCanvasSingleSFPointOperation", operation);
        if (this.isValidSingleSFPointOperation(operation)) {
            if (this.isLightningDesktop() && !["Open", "Edit", "CreateContact"].includes(operation.action)) {
                this.openUrlForOperation(operation);
            } else {
                this.sendEventToRemoteCanvas(operation);
            }
        } else {
            throw new Error("Operation '" + operation.action + "' is not allowed on type '" + operation.object + "'");
        }
    }

    /**
     * 
     * @returns 
     */
    private queryQuickActions() {
        if (!_.isEmpty(this.quickActions)) {
            return es.util.deferred.resolved(this.quickActions);
        }

        es.log.log("Querying quickActions from SF......................");
        const response = {};
        const globalurl = this.signedRequest.context.links.restUrl + "quickActions";
        //Retrieve data using Ajax call
        return this.salesforceRestCall(globalurl, salesforceRestMethods.GET, null, "quickActions").then((salesforceResponse) => {
            _.reduce(quickActionOperations, (memo, quickActionOperation, index, list) => {
                let result = _.filter(salesforceResponse, (action) => {
                    return (
                        action.type === quickActionOperation.type
                        &&
                        action.name === quickActionOperation.name
                    );
                });
                if (result.length === 0) {
                    result = _.filter(salesforceResponse, (action) => {
                        return (
                            action.type === quickActionOperation.type
                            &&
                            action.name.indexOf(quickActionOperation.name) !== -1
                        );
                    });
                }
                if (result.length > 0) {
                    memo[quickActionOperation.name] = result[0];
                }
            }, response);
            es.log.log("Global Actions Response", globalurl, salesforceResponse);
            es.log.log("QuickOperations found: ", response);
            //Store in local variable to prevent querying quickActions again
            this.quickActions = response;
            return es.util.deferred.resolved(response);
        });
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private logACall(operation): JQueryDeferred<any> {
        if (!this.isValidSingleSFPointOperation(operation)) {
            es.log.error("Operation is not allowed", operation);
            return es.util.deferred.rejected("Operation is not allowed");
        }

        return this.queryQuickActions().then((quickActions) => {
            const logACallQuickAction = quickActions[singleSFActions.LogACall];
            if (logACallQuickAction) {
// {"attributes":{"type":"Task"},"Subject":"Call","WhoId":null,"Description":null,"WhatId":null}
                es.log.log("Call LogACall quickAction", quickActions[singleSFActions.LogACall]);
                const logACallRequest = {
                    'records': [
                        {
                            'Subject': operation.params.subject,
                            'Description': operation.params.comment
                        }
                    ]
                };
                if (operation.object === sfObjects.Account) {
                    logACallRequest.records[0].WhatId = operation.params.id;
                } else {
                    logACallRequest.records[0].WhoId = operation.params.id;
                }
                return this.salesforceRestCall(logACallQuickAction.urls.quickAction, salesforceRestMethods.POST, logACallRequest);
            } else {
                //Current user does not have LogACall operation available.
                return es.util.deferred.rejected("The Salesforce action 'Log a Call' is not available to you. Please contact your Salesforce administrator.");
            }
        });
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private addToCampaign(operation): JQueryDeferred<any> {
        if (!this.isValidSingleSFPointOperation(operation)) {
            console.error("Operation is not allowed", operation);
            return es.util.deferred.rejected("Operation is not allowed");
        }

        if (!(operation.params.id && operation.params.campaignId)) {
            console.error("Operation is missing some mandatory data to proceed (operation.params.id, operation.params.campaignId)", operation);
            return es.util.deferred.rejected("Operation is missing some mandatory data to proceed (operation.params.id, operation.params.campaignId)");
        }

        const addToCampaignRequest = {
            'CampaignId': operation.params.campaignId
        };

        if (operation.object === sfObjects.Lead) {
            addToCampaignRequest.LeadId = operation.params.id;
        } else {
            addToCampaignRequest.ContactId = operation.params.id;
        }

        const url = this.signedRequest.context.links.sobjectUrl + "CampaignMember";
        return this.salesforceRestCall(url, salesforceRestMethods.POST, addToCampaignRequest);
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private addToCreate(operation) {
        if (this.isValidSingleSFPointOperation(operation)) {
            if (operation.params) {
                if (operation.object === sfObjects.Lead || operation.object === sfObjects.Contact) {
                    operation.params.WhoId = operation.params.id;
                } else if (operation.object === sfObjects.Account || operation.object === sfObjects.Opportunity) {
                    operation.params.WhatId = operation.params.id;
                }
                delete operation.params.id;
            }
        }

        return this.sendCanvasSingleSFPointOperation(operation);
    }

    /**
     *
     * @param url rest end point to contact
     * @param method if not specified it will use salesforceRestMethods.GET by default
     * @param requestObject object with expected parameters
     * @param cacheKey String if specified then response will be stored in cache using this key
     * @param opts metadata opts for request. supports: suppressDefaultErrorHandling: boolean, noCache: boolean
     * 
     * @returns promise that will be resolved to salesforceResponse.payload if it is successful
     *                  or salesforceResponse in case it fails
     */
    private salesforceRestCall(url: string, method?: any, requestObject?: any, cacheKey?: string, opts?: any): JQueryDeferred<any> {
        const dfd = $.Deferred();
        const noCache = opts && opts["noCache"] === true;

        if(cacheKey && !(noCache) ){
            const item = this.cache.getItem(cacheKey);
            if(item !== null){
                es.log.log("salesforceRestCall : cache HIT :", cacheKey, item);
                return dfd.resolve( es.util.object.deepCopy(item) );
            }
            es.log.log("salesforceRestCall : cache MISS :", cacheKey);
        }

        if (!method) {
            method = salesforceRestMethods.GET;
        }

        es.log.log("salesforceRestCall", url, "ageMs=" + (Date.now() - this.clientCreatedAtMs));

        const settings: any = {
            client: this.signedRequest.client,
            method: method.method,
            contentType: "application/json",
            success: (sfResponse) => {
                if (sfResponse.status == method.status_ok || sfResponse.status == salesforce_status.OK) {
                    es.log.log("salesforceRestCall successful" + (noCache ? " (force no cache)" : ""), url, method);
                    if(cacheKey){
                        this.cache.setItem(cacheKey, es.util.object.deepCopy(sfResponse.payload));
                        es.log.log("salesforceRestCall : SET cache :", cacheKey);
                    }
                    dfd.resolve(sfResponse.payload);
                } else {
                    console.error("There was an error on salesforceRestCall ", sfResponse, url, method, requestObject);
                    dfd.reject(sfResponse);
                    if (sfResponse.status === 401) {
                        es.error.handleSfdcError(sfResponse, url, method, requestObject);
                        return;
                    }
                    if (opts && opts["suppressDefaultErrorHandling"] === true) {
                        return;
                    }
                    es.error.handleSfdcError(sfResponse, url, method, requestObject);
                }
            },
            failure: (sfResponse) => {
                console.error("There was an error on salesforceRestCall (FAIL)", sfResponse, url, method, requestObject, arguments);
                dfd.reject(sfResponse);
                es.error.handleSfdcError(sfResponse, url, method, requestObject);
            }
        };

        if (opts && opts["noCache"] === true) {
            settings.headers = {
                "Authorization": "OAuth " + this.signedRequest.client.oauthToken,
                "Accept": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate"
            };
        }

        if (requestObject) {
            settings.data = JSON.stringify(requestObject);
        }

        this.sfCanvasClient.ajax(url, settings);
        return dfd.promise();
    }

    /**
     * 
     * @param operation 
     * 
     * @returns 
     */
    private changeOwner(operation) {
        if (!this.isValidSingleSFPointOperation(operation)) {
            console.error("Operation is not allowed", operation);
            return es.util.deferred.rejected("Operation is not allowed");
        }

        if (!(operation.params.id && operation.params.ownerId)) {
            console.error("Operation is missing some mandatory data to proceed (operation.params.id, operation.params.ownerId)", operation);
            return es.util.deferred.rejected("Operation is missing some mandatory data to proceed (operation.params.id, operation.params.ownerId)");
        }

        const changeOwnerRequest = {
            'OwnerId': operation.params.ownerId
        };

        let url = this.signedRequest.context.links.sobjectUrl + operation.object + '/' + operation.params.id;
        if (operation.object === sfObjects.Custom) {
            url = this.signedRequest.context.links.sobjectUrl + operation.params.objectName + '/' + operation.params.id;
        }

        return this.salesforceRestCall(url, salesforceRestMethods.PATCH, changeOwnerRequest);
    }

    /**
     * public method
     * @returns object with campaigns {campaigns: [
     *      {
     *      Id: 'CampaignId',
     *      Name: 'CampaignName'
     *      }
     *  ]
     * }
     */
    getCampaigns(): JQueryDeferred<any> {
        const campaignUrl = this.signedRequest.context.links.sobjectUrl + "Campaign";
        //Retrieve data using Ajax call
        return this.salesforceRestCall(campaignUrl, salesforceRestMethods.GET, null, "getCampaigns", {suppressDefaultErrorHandling: true}).then((sfResponse) => {
            const response = {};
            response.campaigns = sfResponse.recentItems;
            es.log.log("Campaign Response", campaignUrl, sfResponse);
            return es.util.deferred.resolved(response);
        }, () => {
            // In case the user does not have access to campaigns, we just return empty array.
            return es.util.deferred.resolved({campaigns: []});
        });
    }

    /**
     * Escape user-entered params for soql queries. See: https://salesforce.stackexchange.com/a/64145
     * @param param
     * @returns {string}
     */
    paramEscape(param: string): string {
        return param.replace("\\", "\\\\").replace("'", "\\'").replace("\"", "\\\"");
    }

    /**
     * public method. Returns users
     * @param name optional search string on Name attribute
     * @param isExact optional exact match of name param or fuzzy. default false/fuzzy.
     * @returns object with users
     * {
     *  users: [
     *            {
     *                Id: 'UserId',
     *                Name: 'UserName'
     *            }
     *         ]
     * }
     */
    getUsers(name?: string, isExact?: boolean): JQueryDeferred<any> {
        if (name) {
            if (isExact) {
                return this.executeQueryRequest("SELECT Id, Name FROM User where isActive = true and Name = '" + this.paramEscape(name) + "' ORDER BY Name limit 8");
            }
            return this.executeQueryRequest("SELECT Id, Name FROM User where isActive = true and (FirstName like '" + this.paramEscape(name) + "%' or LastName like '" + this.paramEscape(name) + "%') ORDER BY Name limit 8", "getUsers_" + name);
        }
        
        return this.executeQueryRequest("SELECT Id, Name FROM User where isActive = true ORDER BY Name", "getUsers");
    }

    /**
     * 
     * @param objectName 
     * @param objectId 
     * @returns 
     */
    getRecordTypeId(objectName, objectId): JQueryDeferred<any> {
        return this.executeQueryRequest(`SELECT ID, RECORDTYPEID FROM ${objectName} WHERE ID = '${objectId}'`,
            `${objectName}_${objectId}`).then(response => {
            if(response.records.length === 0){
                throw new Error(`No records found for ${objectName} with id = '${objectId}'`);
            }
            return response.records[0].RecordTypeId;
        });
    }

    /**
     * public method. Returns result of executing query.
     * @param soql
     * @param cacheKey String if specified then response will be stored in cache using this key
     * @returns promise that will be resolved
     *              to salesforceResponse.payload if it is successful
     *              or salesforceResponse in case it fails
     */
    executeQueryRequest(soql: string, cacheKey?: string): JQueryDeferred<any> {
        soql = this.replaceQueryTokens(soql);
        soql = this.encodeQuery(soql);

        const url = this.signedRequest.context.links.queryUrl + "?q=" + soql;
        // TODO: check callers of this for cache suitability
        return this.salesforceRestCall(url, salesforceRestMethods.GET, null, cacheKey);
    }

    /**
     * 
     * @param object 
     * @param recordTypeId 
     * 
     * @returns 
     */
    getPicklistOptions(object, recordTypeId): JQueryDeferred<any> {
        const url = `${this.signedRequest.context.links.restUrl}ui-api/object-info/${object}/picklist-values/${recordTypeId}`;
        return this.salesforceRestCall(url, salesforceRestMethods.GET, null, `${object}_${recordTypeId}`)
    }

    /**
     * 
     * @param url 
     * 
     * @returns 
     */
    private getUrl(url: string): JQueryDeferred<any> {
        return this.salesforceRestCall(url, salesforceRestMethods.GET, null, null);
    }

    /**
     * 
     * @param query 
     * 
     * @returns 
     */
    private replaceQueryTokens(query: string): string {
        query = query.replaceAll('{{::ES_TOKEN::SF_CURRENT_USER}}', this.signedRequest.context.user.userId);
        return query;
    }

    /**
     * 
     * @param query 
     * 
     * @returns 
     */
    private encodeQuery(query: string): string {
        query = encodeURIComponent(query).replace(/%20/g, "+");
        return query;
    }

    /**
     * public method
     * @returns promise that will be resolved
     *              to salesforceResponse.payload if it is successful
     *              or salesforceResponse in case it fails
     */
    describeGlobal(opts?: any): JQueryDeferred<any> {
        // WARNING: Don't cache this response as it is too big.
        // Could use https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/describe_global_with_ifmodified_header.htm or make this a special case and persist in localstorage.
        // return salesforceRestCall(this.#signedRequest.context.links.restUrl + "sobjects/", salesforceRestMethods.GET, null, "describeGlobal");
        return this.salesforceRestCall(this.signedRequest.context.links.restUrl + "sobjects/", salesforceRestMethods.GET, null, null, opts);
    }
    
    /**
     * public method
     * @returns promise that will be resolved
     *              to salesforceResponse.payload if it is successful
     *              or salesforceResponse in case it fails
     */
    describeCustom(opts): JQueryDeferred<any> {
        const cacheKey = "describeCustom";

        if (!(opts && opts["noCache"] === true)) {
            const item = this.cache.getItem(cacheKey);
            if (item != null) {
                es.log.log("describeCustom : cache HIT :", cacheKey, item);
                return es.util.deferred.resolved(es.util.object.deepCopy(item));
            }
        }

        return this.describeGlobal(opts).then((rs) => {
            const customObjs = rs.sobjects.filter(o => o.custom);
            const customObjsNotSetting = customObjs.filter(o => o.customSetting == false);

            this.cache.setItem(cacheKey, es.util.object.deepCopy(customObjsNotSetting));
            es.log.log("describeCustom : SET cache :", cacheKey);

            return customObjsNotSetting;
        });
    }

    /**
     * public method
     * @param sobjectName
     * @param contextParam optional object to be resolved with param for context to the caller (useful when iterating over an array of custom objs of unknown size)
     * @returns promise that will be resolved
     *              to salesforceResponse.payload if it is successful
     *              or salesforceResponse in case it fails
     */
    describe(sobjectName, contextParam, opts): JQueryDeferred<any> {
        return this.salesforceRestCall(this.signedRequest.context.links.restUrl + 'sobjects/' + sobjectName + '/describe/', salesforceRestMethods.GET, null, "describe/" + sobjectName, opts).then((rs) => {
            if (contextParam) {
                return es.util.deferred.resolved(rs, contextParam);
            }
            
            return rs;
        });
    }

    /**
     * public method to describe a report
     * @param reportId reportId
     * @returns promise that will be resolved
     *              to salesforceResponse.payload if it is successful
     *              or salesforceResponse in case it fails
     */
    describeReport(reportId): JQueryDeferred<any> {
        return this.salesforceRestCall(this.signedRequest.context.links.restUrl + 'analytics/reports/' + reportId + '/describe');
    }

    /**
     * public method to return a list of Reports
     */
    listReports(): JQueryDeferred<any> {
        return this.executeQueryRequest("SELECT Id,Description,Format,LastModifiedDate,LastRunDate,OwnerId,Name,DeveloperName,FolderName FROM Report where (Format = 'Tabular' or Format = 'Summary') order by LastRunDate DESC");
    }

    /**
     * public method
     * @param data
     */
    singleNonSFPoint_NewContact(data) {
        const operation = {
            object: sfObjects.Contact,
            action: singleNonSFActions.CreateContact,
            params: data
        };

        return this.sendCanvasSingleNonSFPointOperation(operation);
    }

    /**
     * It receives an object with the following elements
     * {
     *      action: action from singleSFActions
     *      object: object from sfObjects
     *      params: all parameters that will be needed to perform the action on
     * }
     * and creates an event to communicate with remote visualforce page where the application
     * is running. This will let us use sforce.one api or windows.location
     * @param operation object that contains all information
     */
    private sendCanvasSingleNonSFPointOperation(operation) {
        if (!this.isValidSingleFromNonSFPointOperation(operation)) {
            console.error("Operation is not allowed", operation);
            return;
        }

        this.sendEventToRemoteCanvas(operation)
    }

    /**
     * 
     * @param type 
     * @param layerView 
     * @param feature 
     * @param recordTypeId 
     */
    extractDataForNewSalesforceObject(type: string, layerView: ILayerView, feature, recordTypeId) {
        const operation = {
            object: type,
            recordTypeId: recordTypeId
        };
        if (type == sfObjects.Lead) {
            operation.action = singleNonSFActions.CreateLead;
        } else {
            operation.action = singleNonSFActions.CreateContact;
        }

        if (!this.isValidSingleFromNonSFPointOperation(operation)) {
            es.log.error("Operation is not allowed", operation);
            return;
        }

        if (layerView.$type == 'MapScopeCustomPointLayerView') {
            //es.log.log(feature);
            this.extractFromAddress(type, operation, feature.attrs.ADDRESS);

        } else if (layerView.$type == 'DefaultLayerView') {
            es.api.layerView.getAddressMeta(layerView.id).done((addressMeta) => {
                const data = {};
                this.populateField(type, data, 'STREET', addressMeta, feature.attrs);
                this.populateField(type, data, 'ZIP', addressMeta, feature.attrs);
                this.populateField(type, data, 'CITY', addressMeta, feature.attrs);
                this.populateField(type, data, 'STATE', addressMeta, feature.attrs);
                this.populateField(type, data, 'COUNTRY', addressMeta, feature.attrs);
                operation.params = data;
                this.sendCanvasSingleNonSFPointOperation(operation);
            });
        } else {
            throw new Error("Not supported creation of Salesforce object from layerView" + layerView);
        }
    }

    /**
     * 
     * @param type 
     * @param addressString 
     */
    extractDataForNewTempPointSalesforceObject(type: string, addressString: string) {
        const operation = {
            object: type
        };
        if (type == sfObjects.Lead) {
            operation.action = singleNonSFActions.CreateLead;
        } else {
            operation.action = singleNonSFActions.CreateContact;
        }

        if (!this.isValidSingleFromNonSFPointOperation(operation)) {
            console.error("Operation is not allowed", operation);
            return;
        }

        this.extractFromAddress(type, operation, addressString);
    }

    /**
     * 
     * @param type 
     * @param operation 
     * @param address 
     */
    private extractFromAddress(type: string, operation, address: string) {
        const patterns = {
            'USA': ['STREET', 'CITY', ['STATE', 'ZIP']],
            'CANADA': ['STREET', 'CITY', ['STATE', 'ZIP']],
            'UK': ['STREET', ['CITY', 'ZIP']],
            'FRANCE': ['STREET', ['ZIP', 'CITY']],
            'SPAIN': ['STREET', ['ZIP', 'CITY'],'STATE']
        };

        const addressPartsArray = address.split(',');
        const country = addressPartsArray[addressPartsArray.length - 1].toUpperCase().trim();

        let currentPattern;
        if (patterns[country]) {
            currentPattern = patterns[country];
        } else {
            currentPattern = patterns['USA'];
        }

        if (es.isDeveloper) {
            es.log.log("Address is " + address);
            es.log.log("Country is " + country);
            es.log.log("Pattern is " + currentPattern);
        }

        const finalMapping = {COUNTRY: country};
        for (let i = addressPartsArray.length - 2; i >= 0; i--) {
            const currentAddressPart = addressPartsArray[i].trim();
            const currentPatternPart = currentPattern[i];
            if (es.isDeveloper) {
                es.log.log("currentAddressPart " + currentAddressPart);
                es.log.log("CurrentPatternPart " + currentPatternPart);
            }

            // currentPatternPart is complex
            if (Array.isArray(currentPatternPart)) {
                const splittedCAP = currentAddressPart.split(' ');
                for (let j = 0; j < currentPatternPart.length; j++) {

                    if (j == currentPatternPart.length - 1 && j < splittedCAP.length - 1) {
                        if (es.isDeveloper) {
                            es.log.log("At end of PatternPart and still address parts left, assign them to last patternPart"
                                + currentPatternPart[j] + " value = " + splittedCAP.slice(j, splittedCAP.length).join(' '));
                        }
                        finalMapping[currentPatternPart[j]] = splittedCAP.slice(j,splittedCAP.length).join(' ');
                    } else {
                        if (es.isDeveloper) {
                            es.log.log("As same length we just assign values");
                            es.log.log("Setting field " + currentPatternPart[j] + " with value " + splittedCAP[j]);
                        }
                        finalMapping[currentPatternPart[j]] = splittedCAP[j];
                    }
                }
            } else {
                finalMapping[currentPatternPart] = currentAddressPart;
            }
        }
        if (es.isDeveloper) {
            es.log.log("FinalMapping", finalMapping);
        }

        const data = {};
        const source = {
            'STREET' : ['STREET'],
            'ZIP' : ['ZIP'],
            'CITY' : ['CITY'],
            'STATE' : ['STATE'],
            'COUNTRY' : ['COUNTRY']
        };
        if (finalMapping['STREET']) {
            this.populateField(type, data, 'STREET', source, finalMapping);
        }
        if (finalMapping['ZIP']) {
            this.populateField(type, data, 'ZIP', source, finalMapping);
        }
        if (finalMapping['CITY']) {
            this.populateField(type, data, 'CITY', source, finalMapping);
        }
        if (finalMapping['STATE']) {
            this.populateField(type, data, 'STATE', source, finalMapping);
        }
        if (finalMapping['COUNTRY']) {
            this.populateField(type, data, 'COUNTRY', source, finalMapping);
        }
        operation.params = data;

        this.sendCanvasSingleNonSFPointOperation(operation);
    }

    /**
     * 
     * @param type 
     * @param target 
     * @param name 
     * @param source 
     * @param featureAttrs 
     */
    private populateField(type: string, target, name: string, source, featureAttrs) {
        const attributeNames = source[name];
        const targetName = addressParams[type][name];
        let allValues: string | undefined;
        if (attributeNames) {
            _.each(attributeNames, (attrName) => {
                if (featureAttrs[attrName]) {
                    if (!allValues) {
                        allValues = '';
                    }
                    allValues = allValues + featureAttrs[attrName]
                }
            });
            if (allValues) {
                target[targetName] = allValues;
            }
        }
    }

    /**
     * 
     */
    timeout() {
        this.publish('ess_cnv.timeout');
    }

    /**
     * subscribe to salesforce logout event.
     *
     * @param callback
     */
    //function subscribeLogout(callback){
        //subscribe("ess_cnv.logout", callback);
        //if(es.isDeveloper){
        //    es.log.log("SKIP ess_cnv.logout");
        //}
    //}

    /**
     * Extract SalesforceObjectType from LayerViewId and salesforce id from Feature (based on LayerView and Feature.attribute
     * @param layerViewId
     * @param featureViewId
     * @returns { salesforceObject with two attributes {
     * type : salesforceObjectType,
     * name: objectName (for CustomObjects only) }
     * , SalesforceID }
     * Third return parameter is custom object name if object is custom object
     */
    extractSalesforceObjectTypeExternalID(layerViewId: number, featureViewId: number): JQueryDeferred<any> {
        return $.when(
            es.api.layerView.get(layerViewId),
            es.api.feature.get(layerViewId, featureViewId)
        ).then((layerView, feature) => {
            if (!layerView.importMeta) {
                throw new Exception("trying to extract externalID in layer that does not have it (it is not a salesforce layer)");
            }

            const salesforceObject = {
                type : layerView.importMeta.salesforceObjectType
            };
            if (layerView.importMeta.objectName) {
                salesforceObject.name = layerView.importMeta.objectName;
            }
            
            return es.util.deferred.resolved(salesforceObject, feature.attrs[layerView.externalId]);
        });
    }

    /**
     * 
     * @param recordId 
     */
    openRecordTab(recordId) {
        const url = this.signedRequest.client.instanceUrl + "/" + recordId;
        window.open(url, '_blank');
    }

    /**
     * openUrlForOperation
     *
     * @param operation
     * e.g.:
     * {
     *     "object": "Lead",
     *     "action": "NewEvent",
     *     "params": {
     *         "subtype": "Event",
     *         "newTab": true,
     *         "WhoId": "00Q0O000010Px24UAC"
     *     }
     * }
     *
     * {
     *     "object": "Custom",
     *     "action": "Edit",
     *     "params": {
     *         "id": "a093X00001d8Z8zQAE"
     *     }
     * }
     *
     * {
     *     "object": "Contact",
     *     "action": "Open",
     *     "params": {
     *         "id": "0030O000023ruW8QAI"
     *     }
     * }
     *
     * {
     *     "object": "Account",
     *     "action": "CreateContact",
     *     "params": {
     *         "AccountId": "0013X00003eFmdWQAS",
     *         "Phone": "952-442-1594",
     *         "MailingStreet": "Box #-1089",
     *         "MailingCity": "Minnetonka",
     *         "MailingState": "MN",
     *         "MailingPostalCode": "55345"
     *     }
     * }
     * @see: #sendEventToRemoteCanvas, #createEventFromOperation
     */
    private openUrlForOperation(operation) {
        const objType = operation.params.subtype || operation.object;

        let whoIdOrWhatId = "";
        if (operation.params.hasOwnProperty("WhatId")) {
            whoIdOrWhatId = "WhatId=" + operation.params.WhatId;
        } else if (operation.params.hasOwnProperty("WhoId")) {
            whoIdOrWhatId = "WhoId=" + operation.params.WhoId;
        } else {
            console.warn("Could not determine who or what from operation. skipping", operation);
        }

        let url = this.signedRequest.client.instanceUrl + "/lightning/o/" + objType + "/new?nooverride=true&navigationLocation=RECORD_HOME&defaultFieldValues=" + whoIdOrWhatId;

        /*
        if(operation.params){
            for (let field in operation.params) {
                if (operation.params.hasOwnProperty(field)) {
                    url += "," + field + "=" + operation.params[field];
                }
            }
        }
        */
        es.log.log("Using new window", url, operation);
        window.open(url, '_blank');
    }

    /**
     * Determine if user is lightning mode.
     * see:  https://developer.salesforce.com/docs/atlas.en-us.pages.meta/pages/pages_styling_salesforce_identifying_theme.htm
     * @returns {boolean}
     */
    private isLightningDesktop() {
        const isLightning =
            this.signedRequest.context.environment.uiTheme === 'Theme4d' ||
            this.signedRequest.context.environment.locationUrl.indexOf("lightning.force.com") > -1;

        es.log.log("isLightningDesktop", isLightning);
        return isLightning;
    }
}
